import schema from './schemaVersions/v8.js';
	const finalSchema = { wip: false, ...schema };
	export default finalSchema;